import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import Grid from '@material-ui/core/Grid';

export const HeaderTextContainer3 = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    font-size: 15px;
    color: #000000;
    opacity: 1;
    overflow-y: scroll;
`;

export const PopupContainer = styled.div`
    display: block;
    overflow: hidden;
    padding: 20px;
    ${media.mobileDevice`
    padding: 10px;
    background: #f5f5f5;
    `}
`;

export const Container = styled(Grid)`
    margin-top: 15px;
    width: 100%;
    display: flex;
    ${media.mobileDevice`
    margin-left: 0px;
    margin-bottom: 0px;
    width: 100% !important;
    justify-content: center;
    padding: 0 16px;
`}
`;

export const Container2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: flex;
    width: ${(props) => props.mbWidth && props.mbWidth};
`}
`;

export const HeaderTextContainer2 = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    font-size: 15px;
    color: #000000;
    opacity: 1;
    overflow-y: scroll;
`;

export const Container1 = styled(Grid)`
    justify-content: space-between;
`;

export const ContainerGrid1Desktop = styled(Grid)`
    &.close-icon {
        text-align: end;
    }
    ${media.mobileDevice`
   display: none;
    `}
`;

export const ContainerGrid1Mobile = styled(Grid)`
    display: none;
    ${media.mobileDevice`
   display: block;
    `}
`;
export const ImpersonateIconContainer = styled(Grid)`
    width: 170px;
    height: 36px;
    box-shadow: ${(props) =>
        props.boxShadow ? props.boxShadow : '0px 0px 2px #00000029'};
    border: ${(props) => (props.border ? props.border : '1px solid #1010eb')};
    //background: #ffffff 0% 0% no-repeat padding-box;

    border-radius: 25px;
    opacity: 1;
    justify-content: space-evenly;
    ${media.smalDevice`
   width: 147px;
    `}
    ${media.mobileDevice`
    width: ${(props) => props.mbWidth && props.mbWidth};
   justify-content: space-between;
   //margin-left: 12px;
   margin-top: 4%;
    `}
`;

export const UserProxiesContainer = styled(Grid)`
    width: 170px;
    height: 36px;
    //background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #1010eb;
    border-radius: 25px;
    opacity: 1;
    justify-content: space-evenly;
    margin-right: 8px;
    ${media.smalDevice`
   width: 147px;
    `}
    ${media.mobileDevice`
    width: ${(props) => props.mbWidth && props.mbWidth};
   justify-content: space-between;
   //margin-left: 12px;
   margin-top: 4%;
    `}
`;

export const ImpersonateContainer = styled(Grid)`
    color: ${(props) => (props.labelColor ? props.labelColor : '#1010eb')};
    /* padding-top: 6px;
    padding-left: 15px; */
    padding: 5px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    opacity: 1;
`;

export const ButtonLabel = styled(Grid)`
    display: flex;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    cursor: ${(props) =>
        props.labelColor === '#3d2929ff' ? 'unset' : 'pointer'};
    margin-left: 6px;
    ${'' /* ${media.ipadAir`
        width: 136px;
         `} */}
`;
export const ButtonLabel1 = styled(Grid)`
    display: flex;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    cursor: ${(props) =>
        props.labelColor === '#9f9f9f' ? 'unset' : 'pointer'};
    margin-left: 6px;
`;
export const StyledImage = styled.img`
    display: flex;
    object-fit: contain;
    cursor: pointer;
    padding-bottom: 2px;
    padding-left: 10px;
    ${media.smalDevice`
  padding-left: 0px;
    `}
`;

export const IconContainer = styled(Grid)`
    display: flex;
    justify-content: flex-end;
    ${media.mobileDevice`
    justify-content: center;
    `}
`;

export const Name = styled(Grid)`
    font-family: 'AvenirNextWorld Demi';
    color: #130e4a;
    font-size: 18px;
    ${media.mobileDevice`
   margin-left: 15px;
   margin-top: 12px;
    `}
`;

export const Id = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    color: #130e4a;
    font-size: 18px;
    ${media.mobileDevice`
   display: none;
    `}
`;

export const IdMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
   display: flex;
   margin-left: 15px;
   font-size: 18px;
   color: #130E4A
    `}
`;

export const SapIdDesktop = styled(Grid)`
    font-family: 'AvenirNextWorld Regular';
    color: #767676;
    font-size: 14px;
    margin-left: 5px;
    margin-top: 4px;
    ${media.smalDevice`
    margin-left: 4px;
    `}
    ${media.mobileDevice`
    display: none;
    `}
`;

export const SapIdMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Regular';
    color: #767676;
    font-size: 14px;
    margin-left: 5px;
    margin-top: 4px;
    display: block;
    `}
`;
export const LineDesktop = styled(Grid)`
    color: #767676;
    margin-left: 5px;
    ${media.smalDevice`
margin-left: 3px;
`}
    ${media.mobileDevice`
    display: none;
    `}
`;

export const LineMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
color: #767676;
    margin-left: 5px;
    display: block;
    
`}
`;

export const ContainerGrid1 = styled(Grid)`
    display: flex;
    &.sapIdAndNetID {
        ${media.smalDevice`
        display: none;   
`}
    }
`;

export const IPadPotrait = styled(Grid)`
    display: none;
    ${media.smalDevice`
display: flex;
`}
`;

export const ContainerGrid1Mob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    `}
`;

export const CloseIcon = styled(Icon)`
    width: 21px;
    height: 20px;
    margin: 10px 5px 0 auto;
    ${media.mobileDevice`
    margin-left: 100px;
    width: 20px;
    height: 20px;
    margin-top: 17px;
    `}
`;

export const ProxyPopupContainer = styled.div`
    width: ${(props) => (props.divWidth ? props.divWidth : '430px')};
    display: flex;
    flex-direction: column;
    height: ${({ divHeight }) => (divHeight ? divHeight : '63px')};
    ${media.mobileDevice`
     width:310px;
     height:${(props) => (props.mbDivHeight ? props.mbDivHeight : '160px')}; 
`}
`;
